import CoinbaseWalletSDK from '@coinbase/wallet-sdk';
import IWallet, { IWalletConfig } from '../types';

const Coinbase = ({
  infuraId,
  appName,
  appLogoUrl,
  darkMode,
}: IWalletConfig): IWallet => {
  const getProvider = () => {
    const coinbaseWallet = new CoinbaseWalletSDK({
      appName: appName ?? '',
      appLogoUrl,
      darkMode,
    });

    return coinbaseWallet.makeWeb3Provider(
      `https://mainnet.infura.io/v3/${infuraId}`,
      1
    );
  };

  const isProviderAvailable = (): boolean => {
    // The provider is always available, since it can be injected by us
    return true;
  };

  const isEnabled = async (): Promise<boolean> => {
    const provider = getProvider();
    const accounts = (await provider.request({
      method: 'eth_accounts',
    })) as string[];

    return accounts.length > 0;
  };

  const disconnect = async (provider: any): Promise<void> => {
    await provider.disconnect();
    await provider.close();
  };

  return { isProviderAvailable, getProvider, isEnabled, disconnect };
};

export default Coinbase;
